import React from 'react';
import {DataItem, ToggleButtonInput} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {IDeveloperField} from 'dromo-uploader-react';
import SelectInput from 'src/hook-form-wrapper/select-input';

interface DisplayProps {
  value: string;
}

interface Props {
  name?: string;
  label?: string;
}

export const appointmentTypes = [
  {value: '97151', label: 'Outcome measures'},
  {value: '97153', label: 'Adaptive behavior treatment by protocol'},
  {
    value: '97155',
    label: 'Adaptive behavior treatment with protocol modification',
  },
  {value: '97156', label: 'Family adaptive behavior treatment guidance'},
  {
    value: '00000',
    label: 'Non-Billable',
  },
  {
    value: '92507',
    label: 'Speech/hearing therapy; individual',
  },
  {
    value: '92508',
    label: 'Speech/hearing therapy; group, two or more individuals',
  },
  {
    value: '92522',
    label: 'Evaluate speech production',
  },
  {
    value: '92523',
    label:
      'Evaluation of speech sound production; with evaluation of language comprehension and expression',
  },
  {
    value: '92526',
    label: 'Oral function therapy',
  },
  {value: '92609', label: 'Use of speech device service'},
  {value: '92610', label: 'Evaluate swallowing function'},
  // {value: '97151', label: 'Behavior identification assessment'},
  {value: '97152', label: 'Behavior identification-supporting assessment'},
  {value: '97154', label: 'Group adaptive behavior treatment by protocol'},
  {
    value: '97157',
    label: 'Multiple-family group adaptive behavior treatment guidance',
  },
  {
    value: '97158',
    label: 'Group adaptive behavior treatment with protocol modification',
  },
  {value: '99366', label: 'Medical team conference'},
  {value: '99368', label: 'Medical team conference'},
  {value: '0362T', label: 'Behavior identification supporting assessment'},
  {
    value: '0373T',
    label: 'Adaptive behavior treatment with protocol modification',
  },
  {
    value: 'H0032',
    label: 'Mental health service plan development by non-physician',
  },
  {value: 'T1024', label: 'Team evaluation & management'},
  {value: 'T2024', label: 'Assessment/plan of care development'},
  {value: 'H2019', label: 'Therapeutic behavioral services'},
  {value: '90791', label: 'Psych diagnostic evaluation'},
  {value: '90837', label: 'Psytx w pt 60 minutes'},
  {value: 'H0031', label: 'Mental health assessment, by non-physician'},
  {value: 'H2012', label: 'Behavioral health day treatment, per hour'},
  {value: 'S5111', label: 'Home care training, family; per session'},
  {value: 'H2014', label: 'Skills training and development, per 15 minutes'},
  {value: 'H0046', label: 'Mental health services, not otherwise specified'},
  {
    value: '612',
    label:
      'Behavior Management Assistant (BMA) (Direct therapy by a technician)',
  },
  {
    value: '615',
    label: 'Behavior Management Assistant',
  },
  {
    value: '620',
    label: 'Behavior Management Consultant',
  },
  {value: '616', label: 'Specialized Behavior Management Services'},
  {value: '805', label: 'Infant Development Program (IDP)'},
];

export const Import = (
  key: string = 'appointmentType',
  prefix?: string,
): IDeveloperField => ({
  label:
    (prefix ? prefix + ' ' : '') +
    `Appointment Type (${appointmentTypes
      .map(value => value.label)
      .join(', ')})`,
  key,
  type: 'select',
  selectOptions: appointmentTypes,
  validators: [
    {
      validate: 'required',
    },
  ],
});

const typeFilters = [
  {
    label: 'All',
    value: 'ALL',
  },
  ...appointmentTypes,
];

const resolveDisplayValue = (value: string) => {
  return appointmentTypes.find(item => item.value === value)?.label;
};

const TypeDisplay = ({value}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>Session Type</Text>
      <Text style={[Typography.P3]}>{resolveDisplayValue(value)}</Text>
    </DataItem>
  );
};

const TypeInput = ({name, label}: Props) => {
  return (
    <SelectInput
      name={(name ? name + '.' : '') + 'type'}
      label={label ? label : 'Appointment Type'}
      required={true}
      items={appointmentTypes}
    />
  );
};

const TypeFilter = ({name}: Props) => {
  return (
    <ToggleButtonInput
      name={(name ? name + '.' : '') + 'type'}
      label={'Appointment Type'}
      required={true}
      buttons={typeFilters}
    />
  );
};

export const validation = () =>
  Yup.string().required('Appointment Type is required');

export const Display = TypeDisplay;
export const Input = TypeInput;
export const Filter = TypeFilter;
export const Value = resolveDisplayValue;

export default TypeInput;
